export default __webpack_public_path__ + "static/media/Share-grey.146ddb86.svg";